import { useState } from 'react'

import { useManagementGetNonAllocatedSims } from '@apps-common/apis/management/non-allocated-sim/get-non-allocated-sims'
import { useManagementSearchSimApns } from '@apps-common/apis/management/sim-apn'
import {
  NonAllocatedSimCardSkeleton,
  NonAllocatedSimListCardSm
} from '@apps-common/apps/portal/pages/management/components/non-allocated-sim'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'

export const NonAllocatedSimSelectModal = ({
  onDismiss
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
}) => {
  const [searchVal, setSearchVal] = useState<string>('')

  const { data: apns, isLoading: apnsIsLoading, isError: apnsIsError } = useManagementSearchSimApns({})

  const {
    data: sims,
    isLoading: simsIsLoading,
    isError: simsIsError
  } = useManagementGetNonAllocatedSims({
    search: searchVal
  })

  const isLoading = apnsIsLoading || apnsIsError || simsIsLoading || simsIsError

  return (
    <ModalContainer>
      <ModalHeaderContainer>
        <div className='flex items-center justify-between'>
          <ModalHeader subtitle='Selection' title='Non allocated sims' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pb-0'>
        <div className='overflow-y-scroll sm:max-h-[80lvh] grid sm:grid-cols-2 gap-[20px] pt-[100px] scrollbar-none'>
          {isLoading &&
            Array.from(Array(10).keys()).map((k) => <NonAllocatedSimCardSkeleton key={`non-allocated-sim-list-card-skeleton-${k}`} />)}
          {!isLoading &&
            sims &&
            sims.length > 0 &&
            sims.map((s, i) => (
              <NonAllocatedSimListCardSm
                key={`non-allocated-sim-list-card-${s.id}`}
                sim={s}
                simApns={apns || []}
                callback={(sim: INonAllocatedSimModel) => onDismiss(JSON.stringify(sim), ModalDismiss.Confirm)}
              />
            ))}
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
